import { NumberLike } from "@visx/scale";

import Box from "ds/components/Box";
import { formatCompactNumber } from "utils/number";

import DoraAverage from "../components/Average";
import DoraEmpty from "../components/Empty";
import DoraRange from "../components/DoraRange";
import useDoraChartType from "../useChartType";
import useDoraDeploymentFrequencyRate from "./useRate";
import useDoraDeploymentFrequencyRange from "./useRange";
import { CHART_TYPE_STORAGE_KEY } from "./constants";

const formatRate = (rate: number): string => {
  return `${rate % 1 === 0 ? rate : rate.toFixed(1)} / day`;
};

const formatYAxisLabel = (value: NumberLike) => formatCompactNumber(value.valueOf());

const formatTooltipValue = (value: number) => `${Math.round(value)} runs`;

const DashboardWidgetsDoraDeploymentFrequency = () => {
  const { rate, isLoading: isRateLoading } = useDoraDeploymentFrequencyRate();
  const { range, hasRuns } = useDoraDeploymentFrequencyRange();
  const { chartType } = useDoraChartType(CHART_TYPE_STORAGE_KEY);

  const hasData = hasRuns && !!range?.length;

  if (!hasData) {
    return (
      <DoraEmpty
        title="No deployments yet"
        caption="How often tracked runs complete successfully"
      />
    );
  }

  return (
    <Box direction="column" gap="x-large" fullWidth>
      <DoraAverage formattedValue={formatRate(rate ?? 0)} isLoading={isRateLoading} />
      <DoraRange
        range={range}
        chartType={chartType}
        leftAxisLabel="Runs per day"
        formatYAxisLabel={formatYAxisLabel}
        formatTooltipValue={formatTooltipValue}
      />
    </Box>
  );
};

export default DashboardWidgetsDoraDeploymentFrequency;
